import { render, staticRenderFns } from "./MediaForm.vue?vue&type=template&id=8e664ab4"
import script from "./MediaForm.vue?vue&type=script&lang=js"
export * from "./MediaForm.vue?vue&type=script&lang=js"
import style0 from "./MediaForm.vue?vue&type=style&index=0&id=8e664ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports